import { t } from '@sm/intl';
import COPY from './copy';
import logger from './logger';
import { getLinkGenerator } from '../../../helpers/logging';

const getLink = getLinkGenerator({
  ut_source: 'market_research',
  ut_source2: 'solutions',
  ut_source3: 'subnav'
});

const MENU_CONFIG = Object.freeze({
  solutions: {
    text: t(COPY.solutions),
    menuItems: [
      {
        text: t(COPY.globalSurveyPanel),
        href: getLink('/market-research/solutions/audience-panel', {
          ut_ctatext: 'Global survey panel'
        }),
        logging: () => logger.click.navigateTo('global_survey_panel')
      },
      {
        text: t(COPY.expertSolutions),
        href: getLink('/market-research/our-solutions', {
          ut_ctatext: 'Expert Solutions'
        }),
        logging: () => logger.click.navigateTo('expert_solutions')
      }
    ]
  },
  services: {
    text: t(COPY.services),
    href: getLink('/market-research/services', {
      ut_ctatext: 'Services'
    }),
    onClick: () => logger.click.navigateTo('services')
  },
  moreResources: {
    text: t(COPY.moreResources),
    menuItems: [
      {
        text: t(COPY.audienceTargeting),
        href: getLink('/market-research/audience-targeting', {
          ut_ctatext: 'Audience targeting'
        }),
        logging: () => logger.click.navigateTo('audience_targeting')
      },
      {
        text: t(COPY.dataQuality),
        href: getLink('/market-research/data-quality', {
          ut_ctatext: 'Data quality'
        }),
        logging: () => logger.click.navigateTo('data_quality')
      },
      {
        text: t(COPY.budgetingOptions),
        href: getLink('/market-research/credits', {
          ut_ctatext: 'Budgeting options'
        }),
        logging: () => logger.click.navigateTo('credits')
      },
      {
        text: t(COPY.guidesAndCaseStudies),
        href: getLink('/market-research/resources', {
          ut_ctatext: 'Guides and case studies'
        }),
        logging: () => logger.click.navigateTo('resources')
      }
    ]
  }
});

export default MENU_CONFIG;
